import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import UploadReceipt from "components/UsersDashboard/uploadReceipt";
import { toast } from "react-toastify";
import {
  bookedInspection,
  completedInspection,
} from "@services/krentDeveloper";
import { useNavigate } from "react-router-dom";

interface BookInspectionProps {
  item: {
    _id: string;
    isBooked: boolean;
    inspected: boolean;
    purchaseRequestReceipt: any;
    agent: {
      lastname: string;
      firstname: string;
      phone: string;
    };
  };
  refetchInterests?: () => void;
}
const BookInspection: React.FC<BookInspectionProps> = ({
  item,
  refetchInterests,
}) => {
  const [openBookInspectionModal, setOpenBookInspectionModal] = useState(false);
  const [showProceedtoPayment, setShowProceedtoPayment] = useState(false);
  const [inspectionBtnClicked, setInspectionBtnClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [questionModal, setQuestionModal] = useState(false);
  const [modalAction, setModalAction] = useState<"booked" | "completed">(
    "booked",
  );
  const navigate = useNavigate();
  const handleQuestionModalAction = async () => {
    setIsLoading(true);
    try {
      const abortController = new AbortController();
      const res =
        modalAction === "booked"
          ? await bookedInspection(item._id, abortController.signal)
          : await completedInspection(item._id, abortController.signal);

      if (res && res.message) {
        toast.success(res.message);
      }

      if (modalAction === "completed") {
        setInspectionBtnClicked(true);
      }

      setQuestionModal(false);
      refetchInterests?.();
    } catch (err) {
      const errorMessage =
        err instanceof Error
          ? err.message
          : "An error occurred while processing the inspection";
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };
  const handleGoToMessaging = () => {
    navigate(`/messaging/${item._id}`);
  };

  return (
    <>
      <div className="flex gap-2">
        <button
          onClick={() => setOpenBookInspectionModal(true)}
          className="bg-gray rounded-10 text-black p-2 h-max border-black"
        >
          {item.isBooked ? "Contact Agent" : "Book Inspection"}
        </button>

        {item.isBooked && !item.inspected && !inspectionBtnClicked && (
          <div className="tooltip-container">
            <button
              className="bg-primary rounded-10 text-white p-2 h-max"
              onClick={() => {
                setModalAction("completed");
                setQuestionModal(true);
              }}
              disabled={isLoading}
            >
              Inspection completed?
            </button>
            <span className="tooltip-text">
              Has the inspection been carried out yet? Click ONLY if inspection
              has been completed
            </span>
          </div>
        )}

        {!item.isBooked && (
          <button
            className="bg-white border-green rounded-10 text-primary p-2 h-max"
            onClick={() => {
              setModalAction("booked");
              setQuestionModal(true);
            }}
          >
            Inspection booked?
          </button>
        )}

        {!item?.purchaseRequestReceipt &&
          (item.inspected || inspectionBtnClicked) && (
            <button
              className="bg-black rounded-10 text-white p-2 h-max"
              onClick={() => setShowProceedtoPayment(true)}
            >
              Proceed to payment
            </button>
          )}
      </div>

      <Modal
        show={questionModal}
        onClose={() => setQuestionModal(false)}
        dismissible={false}
      >
        <div className="p-4">
          <div className="flex justify-between gap-2">
            <h5 className="w-full no-text-wrap">
              {modalAction === "booked"
                ? "Has Inspection been booked?"
                : "Has Inspection been completed?"}
            </h5>
            <button
              onClick={() => setQuestionModal(false)}
              className="bg-white"
            >
              <i className="fa-regular fa-x"></i>
            </button>
          </div>
          <div className="flex gap-2 my-4">
            <button
              onClick={handleQuestionModalAction}
              className="bg-primary rounded-10 p-2 w-full text-white"
              disabled={isLoading}
            >
              {isLoading ? "Processing..." : "Yes"}
            </button>
            <button
              onClick={() => setQuestionModal(false)}
              className="border-red text-red bg-white rounded-10 p-2 w-full"
              disabled={isLoading}
            >
              No
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        show={openBookInspectionModal}
        onClose={() => setOpenBookInspectionModal(false)}
        dismissible={false}
      >
        <div className="container py-3">
          <div className="float-right">
            <button
              onClick={() => setOpenBookInspectionModal(false)}
              className="bg-white"
            >
              <i className="fa-regular fa-x"></i>
            </button>
          </div>

          <div className="p-3">
            <h6>Book inspection date with agent</h6>
            <p>Kindly schedule an inspection for the property with the agent</p>
            <div className="py-4">
              <div className="flex gap-2 items-center py-2">
                <h6>Agent : </h6>
                <h6 className="text-primary">
                  {item?.agent?.firstname} {item?.agent?.lastname}{" "}
                </h6>
              </div>
              <div className="flex gap-2 items-center py-2">
                <i className="fa-regular fa-phone"></i>
                <h6>PHONE CALL : </h6>
                <h6 className="text-primary">{item?.agent?.phone}</h6>
              </div>
              <div className="flex gap-2 items-center py-2">
                <i className="fa-regular fa-chat"></i>
                <h6>CHAT WITH AGENT : </h6>
                <button
                  className="text-primary bg-white"
                  onClick={handleGoToMessaging}
                >
                  Go to messaging
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <UploadReceipt
        show={showProceedtoPayment}
        closeModal={setShowProceedtoPayment}
        onClose={() => setShowProceedtoPayment(false)}
        propertyId={item?._id}
        item={item}
      />
    </>
  );
};

export default BookInspection;
